import _ from 'lodash';

function SystemCtrl($rootScope, $scope, $timeout, $state, $stateParams, $compile, toastr, AppSettings, UserService, PlanService, PlayerService) {
  'ngInject';

  const vm = this;
  // window['scope'] = $scope;



  return;
  


}

export default {
  name: 'SystemCtrl',
  fn: SystemCtrl
};
